import { InfoHint } from '../../components/ui';

/**
 * One row of a funnel: label · count · bar · percent, the row itself the
 * button that opens its list. Lived inside PipelineView until drop A gave the
 * Prospecting tab the same funnel; the markup and the .pipeline-step classes
 * are shared so the two funnels can never drift apart.
 */
export function FunnelRow({
  label,
  explainer,
  count,
  percent,
  tone,
  on,
  onPick,
}: {
  label: string;
  explainer: string;
  count: number;
  percent: number;
  tone: 'plain' | 'won' | 'lost';
  on: boolean;
  onPick: () => void;
}) {
  return (
    <div
      role="button"
      tabIndex={0}
      aria-pressed={on}
      className={`pipeline-step pipeline-step--${tone}${on ? ' pipeline-step--on' : ''}`}
      onClick={onPick}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onPick();
        }
      }}
    >
      <span className="pipeline-step-label">
        {label}
        {/* The row is a button and this sits inside it, so before drop 142 a
            click on the ⓘ bubbled up and merely changed the selection. Now it
            would leave the page for the Leads tab, taking the definition the
            person opened it to read with it. Stop here. */}
        <span
          onClick={(event) => {
            event.stopPropagation();
          }}
          onKeyDown={(event) => {
            event.stopPropagation();
          }}
        >
          <InfoHint label={label} text={explainer} />
        </span>
      </span>
      <b className="pipeline-step-count">{count}</b>
      <span className="pipeline-step-track" aria-hidden="true">
        <i style={{ width: `${String(Math.max(percent, 0))}%` }} />
      </span>
      <span className="pipeline-step-percent">{percent}%</span>
    </div>
  );
}
